<template>
  <div>
    <a-menu mode="horizontal" :default-selected-keys="selectedKeys" :selected-keys="selectedKeys" :style="{ lineHeight: '48px' }">
      <template v-for="menu in storeMenus">
        <a-menu-item :key="`${menu.parent_id}-${menu.id}`" @click="onMenuItem(menu.children)">
          <router-link :to="menuRoute(menu)">
            <a-icon v-if="menu.icon" :type="menu.icon" />
            <span>{{ menu.name }}</span>
          </router-link>
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>

<script>
import { listToTree } from '@/utils/utils';

export default {
  data() {
    return {
      menus: []
    };
  },
  computed: {
    selectedKeys() {
      const matched = this.$route.matched;
      var temp = matched[1].meta.id;
      if (matched[1].name === 'projects') {
        this.storeMenus.forEach(item => {
          if (item.code === 'page:project') {
            temp = item.id;
          }
        });
      }
      return [`0-${temp}`];
    },
    storeMenus() {
      return this.$store.state.menus || [];
    }
  },
  mounted() {
    this.setSideMenu();
    // let routerItems = this.$router.options.routes;
    // if (routerItems.length > 0) {
    //   this.meuns = routerItems[0].children;
    //   this.setSideMenu();
    // }
  },
  methods: {
    menuRoute(menu) {
      if (menu.code === 'page:project') {
        return '/projects';
      } else if (menu.redirect) {
        return menu.redirect;
      }
      return menu.route;
    },
    onMenuItem(items) {
      this.$store.commit('setSideMenu', items);
    },
    setSideMenu() {
      const matched = this.$route.matched;
      const activeRouter = matched[1].meta.id;
      const projectId = this.$route.params.project_id;
      for (const menu of this.storeMenus) {
        if (menu.id === activeRouter && matched[1].name !== 'page:project') {
          // 判断当前菜单是否为工程中心，如果不是工程中心则直接取子菜单
          this.$store.commit('setSideMenu', menu.children);
          break;
        } else if (menu.code === 'page:project' && matched[1].name === 'page:project') {
          // 判断当前菜单是否为工程中心，且menu.code为工程中心
          if (menu.children.length > 0) {
            // 如果子菜单中有数据，说明该用户有系统管理员相关权限
            this.$store.commit('setSideMenu', menu.children);
            break;
          } else if (this.$store.state.routers[projectId] !== undefined) {
            // 如果没有系统管理员权限，则判断用户有没有该项目的权限
            this.$store.commit('setSideMenu', listToTree(this.$store.state.routers[projectId], menu.id));
            break;
          } else {
            // 如果都没有权限则提示没有权限，并跳转至项目列表页
            this.$message.warning('没有权限');
            this.$router.push({ name: 'projects' });
          }
        }
      }
    }
  }
};
</script>
